function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaretUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "187.8978 142.1277 136.636 84.373",
    width: 136.636,
    height: 84.373,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 209.004 239.019 L 261.267 186.869 L 313.53 239.019 L 329.585 222.964 L 261.267 154.646 L 192.949 222.964 L 209.004 239.019 Z",
    style: {},
    transform: "matrix(1, 0, 0, 1, -5.051185607910156, -12.518250465393066)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.e5ab0e31.svg";
export { ForwardRef as ReactComponent };